module.exports = __webpack_public_path__ + "static/1038d114-9c8c-4253-b24d-2475b484b7c8-250.b425aa84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/assumption-of-the-virgin-mary/1038d114-9c8c-4253-b24d-2475b484b7c8-250.jpg
// module id = 853
// module chunks = 168707334958949